// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Ch","summaryPar":"Dh","ratingCategories":"Eh","reviewerInfo":"Fh","reviewTypes":"Gh","expanded":"Hh"};